import React, { useEffect, useState } from "react";
import './EditarEsquema.scss'
import GlovalCard from "../../../../components/atoms/GlovalCard/GlovalCard";
import TitleView from "../../../../components/atoms/TitleView/TitleView";
import InputLista from "../../../../components/atoms/InputLista/InputLista";
import { useNavigate, useParams } from "react-router-dom";
import { transferisServiciosIntegracion } from "../../../monitoreo/TransferirServicios/transferisServiciosIntegracion";
import { getTurnos } from "../EsquemasIntegracion";
import { getClients } from "../../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion";
import InputText from "../../../../components/atoms/InputText/InputText";
import InputCalendario from "../../../../components/atoms/InputCalendario/InputCalendario";
import Button from "../../../../components/atoms/Button/Button";
import { convertirFormatoFecha, convertirHoraAmPm, formateoBasico, invertirFormatoFecha, revertirFormatoFecha } from "../../../../utilities/formateos";

const EditarEsquema = ({id_esquema,setActive}) => {
    const navigate = useNavigate()
    const params = useParams()
    const [esquema, setEsquema] = useState([])
    const [lunes, setLunes] = useState(false)
    const [martes, setMartes] = useState(false)
    const [miercoles, setMiercoles] = useState(false)
    const [jueves, setJueves] = useState(false)
    const [viernes, setViernes] = useState(false)
    const [sabado, setSabado] = useState(false)
    const [domingo, setDomingo] = useState(false)
    const [horaInicio,setHoraInicio] = useState(null)
    const [horaFinal,setHoraFinal] = useState(null)
    const [fechaActual,setFechaActual] = useState(formateoBasico(new Date()))
    const [estructuraActivaCheck,setEstructuraActivaCheck] = useState()
    const [estructuraDinamica,setEstructuraDinamica] = useState()
    
    



    useEffect(() => {
        transferisServiciosIntegracion.getEsquemaInfo(id_esquema, setEsquema)
    }, [])
    useEffect(()=>
    {
        if(esquema)
        {
            setDomingo(esquema.DOMINGO)
            setLunes(esquema.LUNES)
            setMartes(esquema.MARTES)
            setMiercoles(esquema.MIERCOLES)
            setJueves(esquema.JUEVES)
            setViernes(esquema.VIERNES)
            setSabado(esquema.SABADO)
            setHoraInicio(esquema.HORA_INICIO)
            setHoraFinal(esquema.HORA_FIN)
            setEstructuraActivaCheck(esquema.ACTIVA)
            setEstructuraDinamica(esquema.DINAMICA)
        }

    },[esquema])
 
    
    const onsubmit =()=>
    {
        const data = {
            domingo:domingo?"1":'0',
            lunes:lunes?"1":'0',
            martes:martes?"1":'0',
            miercoles:miercoles?"1":'0',
            jueves:jueves?"1":'0',
            viernes:viernes?"1":'0',
            sabado:sabado?"1":'0',
            hora_inicio:fechaActual +" "+horaInicio,
            hora_final:fechaActual+" "+horaFinal,
            id:id_esquema,
            estructuraActiva:estructuraActivaCheck?"1":'0',
            esDinamica:estructuraDinamica?"1":'0'

        }
        
        transferisServiciosIntegracion.actualizarEsquema(data,navigate,setActive)
    }
    return (
        <div className="EditarEsquema">
            {/* <TitleView title={"Editar esquemas"}></TitleView> */}
            <GlovalCard>
                    <div className="xbutton"><div className="salir" onClick={()=>{setActive(false)}}>X</div></div>
                <div className="input-container">
                    <div className="container-info">
                        <div className="titulo">CLIENTE:</div>
                        <div className="contenido">{esquema.CLIENTE}</div>
                    </div>
                    <div className="container-info">
                        <div className="titulo">RUTA:</div>
                        <div className="contenido">{esquema.RUTA}</div>
                    </div>
                    <div className="container-info">
                        <div className="titulo">TURNO:</div>
                        <div className="contenido">{esquema.TURNO}</div>
                    </div>
                    <div className="container-info">
                        <div className="titulo">TIPO:</div>
                        <div className="contenido">{esquema.TIPO}</div>
                    </div>
                </div>
                <b>
                    <div className="input-container margin-top">
                        <InputText disabled={false} value={horaInicio} onChange={(e)=>{setHoraInicio(e.target.value)}} title="Hora Inicial" type="time"></InputText>
                        <InputText disabled={false} value={horaFinal} onChange={(e)=>{setHoraFinal(e.target.value)}} title="Hora Final" type="time"></InputText>
                        <div className="check-container"><div className="contenido">L</div>
                            <input onChange={(e)=>{setLunes(e.target.checked)}} checked={lunes?lunes:false} type="checkbox"></input>
                        </div>
                        <div className="check-container"><div className="contenido">M</div>
                            <input onChange={(e)=>{setMartes(e.target.checked)}} checked={martes?martes:false} type="checkbox"></input>
                        </div>
                        <div className="check-container"><div className="contenido">M</div>
                            <input onChange={(e)=>{setMiercoles(e.target.checked)}} checked={miercoles?miercoles:false} type="checkbox"></input>
                        </div>
                        <div className="check-container"><div className="contenido">J</div>
                            <input onChange={(e)=>{setJueves(e.target.checked)}} checked={jueves?jueves:false} type="checkbox"></input>
                        </div>
                        <div className="check-container"><div className="contenido">V</div>
                            <input onChange={(e)=>{setViernes(e.target.checked)}} checked={viernes?viernes:false} type="checkbox"></input>
                        </div>
                        <div className="check-container"><div className="contenido">S</div>
                            <input onChange={(e)=>{setSabado(e.target.checked)}} checked={sabado?sabado:false} type="checkbox"></input>
                        </div>
                        <div className="check-container"><div className="contenido">D</div>
                            <input onChange={(e)=>{setDomingo(e.target.checked)}} checked={domingo?domingo:false} type="checkbox"></input>
                        </div>
                    </div>
                </b>
                <b><label htmlFor="">ACTIVA <input type="checkbox" checked={estructuraActivaCheck?true:false} onChange={(e)=>{setEstructuraActivaCheck(e.target.checked)}}></input></label></b>
                <b style={{marginLeft:"20px"}}><label htmlFor="">ES DINAMICA <input type="checkbox" checked={estructuraDinamica?true:false} onChange={(e)=>{setEstructuraDinamica(e.target.checked)}}></input></label></b>
                <div className="button-container">
                    <Button className={"boton"} onClick={()=>{onsubmit()}}>Actualizar</Button>
                </div>
            </GlovalCard>
        </div>
    )
}
export default EditarEsquema